import { Chip, Paper, Stack, Typography } from '@mui/material'
import { appConnectionCardSurfaceSx } from './appConnectionCardConstants.js'

/**
 * @param {{ safeTitle: string, description?: string, statusLabel: string, chipColor: string }} props
 */
export function AppConnectionCardErrorView({ safeTitle, description, statusLabel, chipColor }) {
  return (
    <Paper
      elevation={0}
      sx={{
        ...appConnectionCardSurfaceSx,
        p: 2,
        borderRadius: 'var(--app-radius-md)',
      }}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between" gap={1}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary' }}>
          {safeTitle}
        </Typography>
        <Chip
          label={statusLabel}
          color={chipColor}
          size="small"
          sx={{ textTransform: 'none', fontWeight: 600, height: 26 }}
        />
      </Stack>
      {description ? (
        <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
          {description}
        </Typography>
      ) : null}
    </Paper>
  )
}
